import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import './blc_highlights.css';
import { useBlcNavScroll } from "../../Blc_Business/BlcHomeLandingPage/HomeWindowThree";
import { BsArrowRight } from "react-icons/bs";

const Blc_Highlight = (props) => {
  const sectionTitle = props.val.blc_highlights_tag.split(" ");
  function newsNumber(valNumber) {
    props.newsNum(valNumber);
  }

  // query string formatting
  function formatQuery(str) {
    return str.split(' ').join('-');
  }

  // blogs in reverse order: latest at first
  const allBLogs = props.val.blc_news.slice().reverse();

  return (


    <section id='highlights'>
      <Container>
        <h2 className="sectionHeading titles">
          <span className='titles-black me-2'>{sectionTitle[0]}</span>
          <span>{sectionTitle[1]}</span>
        </h2>
        <div >
          <Row>
            {allBLogs.map((data, index) => (
              index <= 3 && index === 0 && <Col xs={12} sm={12} md={12} lg={12} xxl={12}
                key={Math.random()}>
                <Link
                  to={`/blchighlights?newsHeading=${formatQuery(data.blc_news_name)}&newsId=${data.id}`}
                  className="highlight" onClick={() => newsNumber(index)}>
                  <Card className="bg-dark text-white" style={{ width: '100%', border: 'none' }} onClick={(e) => newsNumber(index)}>
                    <Card.Img className="img-highlight-hero" loading="eager" src={data.blc_news_img.data[0].attributes.url} alt="blc news" />
                    <Card.ImgOverlay>
                      <div className="article-overlay">
                        <div className="highlight-left">
                          <Card.Title className="hero-article-title"><b>{data.blc_news_name} </b></Card.Title>
                          <p className="hero-article-date">{data.blc_news_date}</p>
                        </div>
                      </div>
                    </Card.ImgOverlay>
                  </Card>
                </Link>
              </Col>
            ))}
            {allBLogs.map((data, index) => (
              index <= 3 && index !== 0 && <Col sm={6} md={4} lg={4} xxl={4} className="py-3" key={Math.random()}>
                <Link
                  to={`/blchighlights?newsHeading=${formatQuery(data.blc_news_name)}&newsId=${data.id}`}
                  className="highlight" onClick={() => newsNumber(index)}>
                  <Card className="bg-dark text-white" style={{ width: '100%', border: 'none' }} onClick={(e) => newsNumber(index)}>
                    <Card.Img className="img-highlight" loading="eager" src={data.blc_news_img.data[0].attributes.url} alt="blc news" />
                    <Card.ImgOverlay>
                      <div className="article-overlay">
                        <div className="highlight-left">
                          <Card.Title className="article-title"><b>{data.blc_news_name} </b></Card.Title>
                          <p className="article-date">{data.blc_news_date}</p>
                        </div>
                      </div>
                    </Card.ImgOverlay>
                  </Card>
                </Link>
              </Col>
            ))}
          </Row>
          <div className="mt-4">
            <Link to="/allnews" className="mt-5 ">
              <Button className="button-color" style={{ padding: '2px 20px' }}>
                <span className="me-2">View All</span>
                <span>
                  <BsArrowRight size={21} />
                </span>
              </Button>
            </Link>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Blc_Highlight;